import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'selectAllCheckboxState',
	standalone: true,
})
export class SelectAllCheckboxStatePipe<T, R> implements PipeTransform {
	transform(selected: R[], filtered: T[]): 'unchecked' | 'checked' | 'indeterminate' {
		if ((selected || []).length !== 0 && (filtered || []).length !== (selected || []).length) {
			return 'indeterminate';
		}
		if (selected?.length) {
			return 'checked';
		}
		return 'unchecked'
	}
}
